import { useQuery } from "@tanstack/react-query";
import { getAccessRoleListWithPermissions } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const ACCESS_ROLES_WITH_PERMISSIONS_QUERY_KEY = "ACCESS_ROLES_WITH_PERMISSIONS";

export const accessRoleKeys = {
  all: [ACCESS_ROLES_WITH_PERMISSIONS_QUERY_KEY],
  withPermissions: () => [...accessRoleKeys.all, "WITH_PERMISSIONS"],
};

export const useAccessRolesWithPermissionsQuery = () =>
  useQuery({
    queryKey: accessRoleKeys.withPermissions(),
    queryFn: processResponseWithApiProblemDetails(() =>
      getAccessRoleListWithPermissions(),
    ),
  });
